import { render, staticRenderFns } from "./MinisiteContact.vue?vue&type=template&id=cfab1450&scoped=true&"
import script from "./MinisiteContact.vue?vue&type=script&lang=js&"
export * from "./MinisiteContact.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteContact.vue?vue&type=style&index=0&id=cfab1450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfab1450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfab1450')) {
      api.createRecord('cfab1450', component.options)
    } else {
      api.reload('cfab1450', component.options)
    }
    module.hot.accept("./MinisiteContact.vue?vue&type=template&id=cfab1450&scoped=true&", function () {
      api.rerender('cfab1450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteContact.vue"
export default component.exports